/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { Metadata } from '../../models/metadata';

export interface GetProviders1$Params {}

export function getProviders1(
   http: HttpClient,
   rootUrl: string,
   params?: GetProviders1$Params,
   context?: HttpContext
): Observable<StrictHttpResponse<Metadata>> {
   const rb = new RequestBuilder(rootUrl, getProviders1.PATH, 'get');
   if (params) {
   }

   return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
         return r as StrictHttpResponse<Metadata>;
      })
   );
}

getProviders1.PATH = '/api/weather/meta';
